export default __webpack_public_path__ + "static/airpulse-49bc90508e8ec182e99dc2287515036e.jpg";